import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {GetIncomeTaxPDF, GetIncomeTaxPDFParams, GetIncomeTaxPDFModel} from 'domain/usecases';

export class RemoteGetIncomeTaxPDF implements GetIncomeTaxPDF {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetIncomeTaxPDFModel>,
	) {}

	async get({signal, ...params}: GetIncomeTaxPDFParams): Promise<GetIncomeTaxPDFModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			responseType: 'blob',
			params,
			signal,
		});
		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
